export const QUERY_KEYS = {
  trainerList: 'trainer-list' as const,
  trainerDetail: 'trainer-detail' as const,
  trainerSchedule: 'trainer-schedule' as const,
  trainerMySchedule: 'trainer-my-schedule' as const,
  trainerWorkingDays: 'trainer-working-days' as const,
  trainerClassHistory: 'trainer-class-history' as const,
  trainerPrivateTrainingHistory: 'trainer-pt-history' as const,
  trainerPtTrainingHistoryMembers: 'trainer-pt-training-history-members' as const,
  trainerGoalSettings: 'trainer-goal-settings' as const,
  goalSettingDetail: 'goal-setting-detail' as const,
  swimmingGoalSettingDetail: 'swimming-goal-setting-detail' as const,
  goalSettingSessionDetail: 'goal-setting-session-detail' as const,
  goalSettingSessions: 'goal-setting-sessions' as const,
  goalSettingEditLogs: 'goal-setting-edit-logs' as const,
  swimmingGoalSettingEditLogs: 'swimming-goal-setting-edit-logs' as const,
  memberDetail: 'member-detail' as const,
  customers: 'customers' as const,
  userCredit: 'user-credit' as const,
  userById: 'user-by-id' as const,
  userMembership: 'user-membership' as const,
  trainerServices: 'trainer-services' as const,
  coachDetail: 'coach-detail' as const,
  coachSchedule: 'coach-schedule' as const,
  coachWorkingDays: 'coach-working-days' as const,
  swimmingCoachList: 'swimming-coach-list' as const,
  CoachClassHistory: 'coach-class-history' as const,
  coachSwimmingTrainingHistory: 'coach-swimming-training-history' as const,
  coachSwimmingClientHistory: 'coach-swimming-client-history' as const,
  swimmingCoachGoalSettings: 'swimming-coach-goal-settings' as const,
  accessControlDoors: 'access-control-doors' as const,
  accessControlDoorDetail: 'access-control-door-detail' as const,
  trainerPerformance: 'trainer-performance' as const,
  clubInfo: 'club-info' as const,
  fitnessBanks: 'fitness-banks' as const,
  bankFees: 'bank-fees' as const,
  membershipCard: 'membership-card' as const,
  branches: 'branches' as const,
  branchReceiptSettings: 'branch-receipt-settings' as const,
  leadFormSettings: 'lead-form-settings' as const,
  autoBanSettings: 'auto-ban-settings' as const,
  memberNoShowStatus: 'member-no-show-status' as const,
  tenantInfo: 'tenant-info' as const,
  exerciseList: 'exercise-list' as const,
  exerciseDetail: 'exercise-detail' as const,
  exerciseCategories: 'exercise-categories' as const,
  workoutTemplateList: 'workout-template-list' as const,
  workoutTemplateDetail: 'workout-template-detail' as const,
  provinces: 'provinces' as const,
  districts: 'districts' as const,
  subDistricts: 'sub-districts' as const,
  mcpOAuthRequest: 'mcp-oauth-request' as const,
  mcpOAuthGrantPreview: 'mcp-oauth-grant-preview' as const,
  mcpOAuthGrants: 'mcp-oauth-grants' as const,
}

export const TRAINER_LIST_QUERY_KEY = QUERY_KEYS.trainerList
export const TRAINER_DETAIL_QUERY_KEY = QUERY_KEYS.trainerDetail
export const TRAINER_SCHEDULE_QUERY_KEY = QUERY_KEYS.trainerSchedule
export const TRAINER_MY_SCHEDULE_QUERY_KEY = QUERY_KEYS.trainerMySchedule
export const TRAINER_WORKING_DAYS_QUERY_KEY = QUERY_KEYS.trainerWorkingDays
export const TRAINER_CLASS_HISTORY_QUERY_KEY = QUERY_KEYS.trainerClassHistory
export const TRAINER_PT_HISTORY_QUERY_KEY = QUERY_KEYS.trainerPrivateTrainingHistory
export const TRAINER_PT_TRAINING_HISTORY_MEMBERS_QUERY_KEY =
  QUERY_KEYS.trainerPtTrainingHistoryMembers
export const TRAINER_GOAL_SETTINGS_QUERY_KEY = QUERY_KEYS.trainerGoalSettings
export const GOAL_SETTING_DETAIL_QUERY_KEY = QUERY_KEYS.goalSettingDetail
export const SWIMMING_GOAL_SETTING_DETAIL_QUERY_KEY = QUERY_KEYS.swimmingGoalSettingDetail
export const GOAL_SETTING_SESSION_DETAIL_QUERY_KEY = QUERY_KEYS.goalSettingSessionDetail
export const GOAL_SETTING_SESSIONS_QUERY_KEY = QUERY_KEYS.goalSettingSessions
export const GOAL_SETTING_EDIT_LOGS_QUERY_KEY = QUERY_KEYS.goalSettingEditLogs
export const SWIMMING_GOAL_SETTING_EDIT_LOGS_QUERY_KEY = QUERY_KEYS.swimmingGoalSettingEditLogs
export const MEMBER_DETAIL_QUERY_KEY = QUERY_KEYS.memberDetail
export const CUSTOMERS_QUERY_KEY = QUERY_KEYS.customers
export const USER_CREDIT_QUERY_KEY = QUERY_KEYS.userCredit
export const USER_BY_ID_QUERY_KEY = QUERY_KEYS.userById
export const USER_MEMBERSHIP_QUERY_KEY = QUERY_KEYS.userMembership
export const TRAINER_SERVICES_KEY = QUERY_KEYS.trainerServices
export const COACH_DETAIL_QUERY_KEY = QUERY_KEYS.coachDetail
export const COACH_SCHEDULE_QUERY_KEY = QUERY_KEYS.coachSchedule
export const COACH_WORKING_DAYS_QUERY_KEY = QUERY_KEYS.coachWorkingDays
export const COACH_CLASS_HISTORY_QUERY_KEY = QUERY_KEYS.CoachClassHistory
export const SWIMMING_COACH_LIST_QUERY_KEY = QUERY_KEYS.swimmingCoachList
export const COACH_SWIMMING_TRAINING_HISTORY_QUERY_KEY = QUERY_KEYS.coachSwimmingTrainingHistory
export const COACH_SWIMMING_CLIENT_HISTORY_QUERY_KEY = QUERY_KEYS.coachSwimmingClientHistory
export const SWIMMING_COACH_GOAL_SETTINGS_QUERY_KEY = QUERY_KEYS.swimmingCoachGoalSettings
export const ACCESS_CONTROL_DOORS_QUERY_KEY = QUERY_KEYS.accessControlDoors
export const ACCESS_CONTROL_DOOR_DETAIL_QUERY_KEY = QUERY_KEYS.accessControlDoorDetail
export const TRAINER_PERFORMANCE_QUERY_KEY = QUERY_KEYS.trainerPerformance
